module.exports = __webpack_public_path__ + "img/purr_purrspace.f0f56e3.png";